"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _gift = require("../../store/gift/gift.actions");

var _gift2 = require("../../store/gift/gift.selector");

var _message = require("../../store/gift/postcard/message");

var _invitationType = require("../../store/gift/invitationType");

var _emailProviders = require("../../constants/emailProviders.constant");

var _EmailIntegrationBroken = _interopRequireDefault(require("../EmailIntegration/EmailIntegrationBroken"));

var _templates = require("../../store/templates/templates.actions");

var _templates2 = require("../../store/templates/templates.selector");

var headerMapper = (0, _ramda.cond)([[(0, _ramda.equals)(_invitationType.VirtualGiftInvitationMethod.link), (0, _ramda.always)('Craft your message for the landing page')], [(0, _ramda.equals)(_invitationType.VirtualGiftInvitationMethod.direct), (0, _ramda.always)('Craft your message for the card')], [_ramda.T, (0, _ramda.always)('Craft your message for the email')]]);

var GiftMessageHeader = function GiftMessageHeader() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var template = (0, _reactRedux.useSelector)(_message.getTemplateName);
  var emailProvider = (0, _reactRedux.useSelector)(_gift2.getGiftEmailProvider);
  var giftId = (0, _reactRedux.useSelector)(_gift2.getGiftId);
  var defaultTemplate = (0, _reactRedux.useSelector)(_templates2.getDefaultTemplate);
  var isDirectMailInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var selectedInvitationType = (0, _reactRedux.useSelector)(_invitationType.getSelectedInvitationType);
  var id = (0, _ramda.propOr)('', 'id', emailProvider);
  var primaryEmailLabel = (0, _ramda.propOr)('', 'primary_email_label', emailProvider);
  var secondaryEmailLabel = (0, _ramda.propOr)('', 'secondary_email_label', emailProvider);
  var isIntegrationWarningVisible = (0, _reactRedux.useSelector)(_gift2.getIsBrokenIntegrationWarningVisible);
  var isAllowEditTemplate = (0, _reactRedux.useSelector)(_gift2.getIsAllowEditTemplate);
  var isEmailInvitation = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedEmailInvitationType);
  var isDefaultProvider = id === _emailProviders.EMAIL_PROVIDERS.DEFAULT;
  var isDefaultEmailProvider = isEmailInvitation && isDefaultProvider;
  var isCustomEmailProvider = isEmailInvitation && !isDefaultProvider;
  var isSecondaryEmailVisible = (!isEmailInvitation || isCustomEmailProvider) && !isDirectMailInvitationType;
  (0, _react.useEffect)(function () {
    if (!isAllowEditTemplate) {
      dispatch((0, _templates.loadTemplatesRequest)(giftId));
    }
  }, [isAllowEditTemplate, dispatch, giftId]);
  (0, _react.useEffect)(function () {
    if (defaultTemplate && !isAllowEditTemplate) {
      dispatch((0, _gift.selectTemplate)(defaultTemplate));
    }
  }, [isAllowEditTemplate, dispatch, defaultTemplate]);
  var onGoBackClick = (0, _react.useCallback)(function () {
    if (isAllowEditTemplate) {
      dispatch((0, _gift.selectTemplate)(null));
    }
  }, [isAllowEditTemplate, dispatch]);
  var headerTitle = (0, _react.useMemo)(function () {
    return headerMapper(selectedInvitationType === null || selectedInvitationType === void 0 ? void 0 : selectedInvitationType.id);
  }, [selectedInvitationType === null || selectedInvitationType === void 0 ? void 0 : selectedInvitationType.id]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pr: 2,
    pl: 6,
    py: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, headerTitle)), isDirectMailInvitationType ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    px: 2,
    pt: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Format used will apply directly to the printed note including line breaks. Please avoid the use of emojis.")) : /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 2,
    display: "flex",
    justifyContent: "space-between",
    bgcolor: "green.fruitSaladLight"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    className: "Body-Regular-Left-Static"
  }, template && /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Template: ", /*#__PURE__*/_react.default.createElement("span", {
    className: "Body-Regular-Left-Static-Bold"
  }, template))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    className: "Body-Regular-Left-Link-Bold ".concat(isAllowEditTemplate ? 'Text-Pointer' : 'Pointer-Events-None Text-Pointer-NotAllowed '),
    title: isAllowEditTemplate ? '' : 'Only the designated message template is allowed for this campaign',
    onClick: onGoBackClick
  }, "Go back to your templates")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, isIntegrationWarningVisible && /*#__PURE__*/_react.default.createElement(_EmailIntegrationBroken.default, {
    mx: 2,
    mt: 3
  }), !isDirectMailInvitationType && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    p: 3,
    pb: 1,
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mr: 1,
    color: "green.main"
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "graduation-cap",
    color: "inherit"
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Subcopy-Static-Alt",
    mr: 1
  }, "Protip:"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Subcopy-Static-Alt"
  }, isDefaultEmailProvider && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "The initial email and all follow up emails for this invitation will be sent through", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "Subcopy-Static"
  }, primaryEmailLabel)), isCustomEmailProvider && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "The initial email for this invitation will be sent through"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Subcopy-Static",
    mb: 1
  }, primaryEmailLabel)), isSecondaryEmailVisible && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "All follow up emails for this invitation will be sent through"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Subcopy-Static"
  }, secondaryEmailLabel))))));
};

GiftMessageHeader.propTypes = {};

var _default = /*#__PURE__*/(0, _react.memo)(GiftMessageHeader);

exports.default = _default;